import React from 'react'

function Error() {
  return (
    <div>
      Error
Error
    </div>
  )
}

export default Error
